import React from 'react';
import ReactDOM from 'react-dom';
import DOMTooltip from '@/components/common/DOMTooltip';

const MOUNTED_ATTR = 'data-tooltip-mounted';

const mountFor = (el: HTMLElement) => {
  if (el.hasAttribute(MOUNTED_ATTR)) return;
  el.setAttribute(MOUNTED_ATTR, 'true');

  const mountPoint = document.createElement('span');
  mountPoint.style.display = 'contents';
  el.parentElement?.insertBefore(mountPoint, el.nextSibling);

  ReactDOM.render(<DOMTooltip target={el} />, mountPoint);
};

const scan = (root: ParentNode) => {
  root.querySelectorAll<HTMLElement>('[data-tooltip]').forEach(mountFor);
};

// AIDEV-NOTE: Auto-init for [data-tooltip] elements. Mirrors Tippy v3's auto-init
// paradigm but renders an accessible TCITooltip (Radix) per match. A MutationObserver
// catches dynamically-added nodes after first paint. Idempotent — extra calls no-op.
let initialized = false;

export default function initTooltips() {
  if (initialized) return;
  initialized = true;

  scan(document);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        if (node.hasAttribute('data-tooltip')) mountFor(node);
        scan(node);
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
}
